(function () {
    'use strict';

    angular
        .module('oddQuestionnaireTemplateModule')
        .directive('oddQuestionAttachments', directive);

    directive.$inject = [];

    function directive() {
        return {
            restrict: 'E',
            scope: {
                question: '=',
                isDisabled: '=',
                showUserDefined: '&',
                required: '&',
                fieldIndex: '@',
                labelChanged: '&',
                fieldRequirement: '&',
                labelUniqueError: '='
            },
            require: ['^form'],
            templateUrl: require('./oddQuestionAttachments.tpl.html'),
            link: function ($scope, $element, $attrs, $ctrl) {
                $scope.form = $ctrl[0];
                $scope.init();
                $scope.validate();
            },
            controller: ['$rootScope', '$scope', '$timeout', 'oddQuestionnaireTemplateService', function ($rootScope, $scope, $timeout, oddQuestionnaireTemplateService) {
                // TODO change to a param sent to the directive
                var isFieldAttachment = $scope.question.ODDQuestionType.Code === 'FieldAttachment';

                $scope.showUserDefined = $scope.showUserDefined();
                $scope.required = $scope.required();
                $scope.edit = !isFieldAttachment && !$scope.isDisabled;

                // TODO temporary disables user defined attachments
                $scope.showUserDefined = false;

                var rejectedCharacers = /(\+|\\)+/;

                $scope.init = init;
                $scope.add = add;
                $scope.remove = remove;
                $scope.updateUserDefinedAttachment = updateUserDefinedAttachment;
                $scope.validate = validate;
                $scope.updateComponentField = updateComponentField;

                function init() {
                    // add an attachment on init when it is a field attachment question type.
                    if (isFieldAttachment) {
                        if (!$scope.question.ODDQuestionAttachments ||  !$scope.question.ODDQuestionAttachments.length) {
                            add();
                        }
                    }
                }

                function validate() {
                    var hasAttachments = !!($scope.question.ODDQuestionAttachments  && $scope.question.ODDQuestionAttachments.length > 0);

                    setQuestionAttributeValue($scope.question.ODDQuestionAttributeValues, 'WithAttachment', String.valueOf()( hasAttachments ));

                    if ($scope.required) {
                        $scope.form.$setValidity('ODDQuestionAttachments', hasAttachments);
                    }
                }

                function updateComponentField(attachment, $index) {
                    var valid = !rejectedCharacers.test(attachment.Label);
                    attachment._showInvalidCharsTooltip = !valid;
                    $scope.form['attachmentLabel.'+$index].$setValidity('ODDInvalidLabelChars', valid);

                    if (isFieldAttachment) {
                        manageComponentField();
                        $scope.labelChanged({index: $scope.fieldIndex});
                    }
                }

                $scope.updateComponentFieldRequirement = function () {
                    if (isFieldAttachment) {
                        manageComponentField();
                    }
                    $scope.fieldRequirement();
                };

                function manageComponentField() {
                    $scope.question.TitleEN = $scope.question.ODDQuestionAttachments[0].Label;
                    $scope.question.IsRequired = _.some($scope.question.ODDQuestionAttachments, function (qAttachment) {
                        return qAttachment.IsRequired;
                    });
                }

                function updateUserDefinedAttachment() {
                    _.remove($scope.question.ODDQuestionAttachments, { isUserDefined: true });

                    if ($scope.userDefinedAttachmentBoolean) {
                        $scope.userDefinedAttachment = { isUserDefined: true, IsRequired: false };
                        $scope.question.ODDQuestionAttachments.push($scope.userDefinedAttachment)
                    }

                    $scope.form.$setDirty();
                    validate();
                }

                function setQuestionAttributeValue(attributeValues, code, value) {
                    _.set(_.find(attributeValues, { 'Code': code }), 'ValueText', value);
                }

                function getQuestionAttributeValue(code) {
                    return _.find($scope.question.ODDQuestionType.ODDQuestionAttributeValues, {Code: code});
                }

                function add() {
                    if (!$scope.question.ODDQuestionAttachments) {
                        $scope.question.ODDQuestionAttachments = [];
                    }

                    $scope.question.ODDQuestionAttachments.push({
                        IsRequired: true,
                        IsUserDefined: false
                    });

                    $scope.form.$setDirty();
                    validate();

                    $timeout(function () {
                        $scope.$broadcast('focus.attachment.' + ($scope.question.ODDQuestionAttachments.length - 1));
                    });
                }

                function remove(index) {
                    $scope.question.ODDQuestionAttachments.splice(index, 1);

                    $scope.form.$setDirty();
                    validate();
                }
            }]
        }
    }
})();